function n(i) {
  return i == null || i === void 0;
}
export {
  n as isNill
};
